/**
 * Brand Constants
 *
 * Stock Sentry brand colors and styling constants.
 * Derived from Figma design system.
 *
 * Used by:
 * - OnboardingWizard (wizard styling)
 * - StepIndicator (progress bar and step circles)
 * - SuccessStep (completion animation)
 * - Dashboard header (logo and branding)
 */

/**
 * Primary brand purple color
 * Matches Figma design specification
 */
export const BRAND_PURPLE = '#8b7bd8';

/**
 * Brand purple with transparency for shadow/glow effects
 */
export const BRAND_PURPLE_SHADOW = 'rgba(139, 123, 216, 0.1)';

/**
 * Brand purple with stronger transparency for hover states
 */
export const BRAND_PURPLE_HOVER = 'rgba(139, 123, 216, 0.15)';

/**
 * Brand purple glow for success animations
 */
export const BRAND_PURPLE_GLOW = 'rgba(139, 123, 216, 0.2)';
